<p-dialog [(visible)]="overdraftDialogVisible" [resizable]="false" [draggable]="true" [modal]="true"
          styleClass="w-35rem">
  <ng-template #header>
    {{ 'tradingBusiness.dialog.header.creditLimitOverrun' | translate }}
  </ng-template>
  @if (isDzBankUser() && selectedCustomer()?.limitbank) {
    {{ 'raising.label.limitbankCreditLimitOverrun' | translate }}
    <br />
    <br />
    {{ 'tradingBusiness.dialog.body.creditLimitOverrun' | translate }}
  } @else {
    {{ 'tradingBusiness.dialog.body.creditLimitOverrun' | translate }}
  }
  <ng-template #footer>
    <p-button label="{{'common.cancel' | translate}}" severity="secondary" variant="outlined" icon="pi pi-times"
              (onClick)="onCancel()" />
    <p-button label="{{'common.release' | translate}}" severity="primary" variant="outlined" icon="pi pi-check-square"
              (onClick)="processExecuteAfterLimitOverrun()" />
  </ng-template>
</p-dialog>
